import React from 'react';
import PropTypes from 'prop-types';
import Button from '@prisjakt/ui-button';
import Spinner from '@prisjakt/ui-spinner';

const SubmitButton = props => (
  <Button
    disabled={props.loading}
    {...props}
    icon={props.loading ? <Spinner position="none" isActive /> : null}
  >
    {!props.loading && <span>{props.text}</span>}
  </Button>
);

SubmitButton.propTypes = {
  ...Button.propTypes,
  children: PropTypes.node,
  loading: PropTypes.bool,
  type: PropTypes.string,
  small: PropTypes.bool,
  wide: PropTypes.bool,
  rounded: PropTypes.bool,
  styling: PropTypes.string,
  outlined: PropTypes.bool,
};

SubmitButton.defaultProps = {
  type: 'submit',
  small: true,
  wide: true,
  rounded: true,
  styling: 'secondary',
  loading: false,
  outlined: false,
  children: undefined,
};

export default SubmitButton;
